import { LOGOUT_ERROR } from '../constants/login-constants';
import { getClientId, getClientSecret, getEndpoint } from '../helper/apiConfigHelper';
import { LogoutInvalidToken, RefreshTokenReload, getCookie } from '../utils/utils';
import { fetchWithRetry } from './fetchWithRetry';
import { logNewRelicError } from '../helper/newRelicHelper';

const HTTP_METHODS = Object.freeze({
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT',
    DELETE: 'DELETE'
});

const MuleFetchUtil = (() => {
    const dataCache = {};

    const defaultConfig = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    let controller = new AbortController();

    const stringToHex = (str) => {
        var arr = [];
        for (var i = 0; i < str.length; i++) {
            arr[i] = ("00" + str.charCodeAt(i).toString(16)).slice(-4);
        }
        return arr.join('');
    };

    const request = (url, method, headerConfig, body,actionType) => {
        const clientConfigs = {
            "client_id": getClientId(headerConfig.countryCode),
            "client_secret": getClientSecret(headerConfig.countryCode),
         "countryCode": headerConfig.countryCode,
         "customerToken":headerConfig.customerToken
        };
        if (headerConfig.countryCode === "idic") {
            headerConfig.countryCode = "id";
            clientConfigs.countryCode = headerConfig.countryCode;
            clientConfigs.businessGroup = "ic";
          }
        const headers = {
          ...defaultConfig,
          ...clientConfigs,
          "action":actionType,
           "channel": "CH",
              "source": "cohort",

        };
        const requestConfig = {
            method,
            headers,
            signal: controller.signal,
        };
        if (method === HTTP_METHODS.POST || method === HTTP_METHODS.PUT) {
            requestConfig.body =JSON.stringify(body)
        }
        if(method===HTTP_METHODS.POST && (actionType==="refreshToken" || actionType==="logout")){
            requestConfig.headers={
                ...headers,"Customertoken":getCookie("idToken")
            }
        }
        const finalURL = `${getEndpoint(headerConfig.countryCode)}${url} `
        const req = new Request(finalURL, requestConfig);
        return new Promise((resolve, reject) => {
            fetchWithRetry(req, 2, 1000)
                .then(response => {
                    if (response) {
                        if (response.ok && response.status >= 200 && response.status <= 299) {
                            return response.json();
                        }
                        else if(response.status >= 400 && response.status < 500){
                            return response.json();
                        } 
                        else if(response.status >= 500){
                            return response.json();
                        } 
                        else {
                            throw new Error(response);
                        }
                    }
                })
                .then((data) => {
                    if(data.statusCode >= 500 && 
                        data?.errors?.errorPayload?.error?.message ==="INVALID_ID_TOKEN" 
                        || data.status === 407
                    ){
                        const refreshToken=getCookie("refreshToken");
                        if(refreshToken){
                            RefreshTokenReload(refreshToken);
                        }else{
                            LogoutInvalidToken();
                        }
                      } else if (data.statusCode === 404 && data?.errors?.errorMessage === LOGOUT_ERROR) {
                        LogoutInvalidToken();
                      }
                      if(data?.statusCode != 200) {
                        logNewRelicError(data)
                      }
                    dataCache[stringToHex(req)] = data;
                    resolve(data);
                }, (error) => {
                    reject(error);
                });
        });
    };

    const abort = () => controller.abort();

    return {
        post: (url, headerConfig = {}, body,actionType) => {
            return request(url, HTTP_METHODS.POST, headerConfig, body,actionType);
        },
        get: (url, headerConfig = {}) => {
            return request(url, HTTP_METHODS.GET, headerConfig);
        },
        put: (url, headerConfig = {}, body) => {
            return request(url, HTTP_METHODS.PUT, headerConfig, body);
        },
        delete: (url, headerConfig = {}) => {
            return request(url, HTTP_METHODS.DELETE, headerConfig);
        },
        abort: () => {
            abort();
            controller = new AbortController();
        }
    }
})();

export default MuleFetchUtil;
